{
  "courses": [
    {
      "id": 1,
      "name": "Green Meadows",
      "grade": "green",
      "seed": 1001,
      "legs": [
        { "zone": "meadow", "lengthM": 700 },
        { "zone": "forest", "lengthM": 800 }
      ],
      "bigfoot": { "zone": "forest", "offsetM": 100, "aggression": 0.4, "scare": false },
      "finish": "banner"
    },
    {
      "id": 2,
      "name": "Red Scree",
      "grade": "red",
      "seed": 2002,
      "legs": [
        { "zone": "scree", "lengthM": 900 },
        { "zone": "meadow", "lengthM": 800 },
        { "zone": "forest", "lengthM": 1000 },
        { "zone": "valley", "lengthM": 300 }
      ],
      "bigfoot": { "zone": "forest", "offsetM": 50, "aggression": 0.6, "scare": false },
      "finish": "village"
    },
    {
      "id": 3,
      "name": "Black Summit",
      "grade": "black",
      "seed": 3003,
      "legs": [
        { "zone": "summit", "lengthM": 1000 },
        { "zone": "scree", "lengthM": 1000 },
        { "zone": "meadow", "lengthM": 900 },
        { "zone": "forest", "lengthM": 1200 },
        { "zone": "valley", "lengthM": 400 }
      ],
      "bigfoot": { "zone": "forest", "offsetM": 0, "aggression": 0.8, "scare": true },
      "finish": "village"
    }
  ],
  "freeride": {
    "cycle": [
      { "zone": "meadow", "lengthM": 800 },
      { "zone": "forest", "lengthM": 800 }
    ],
    "bigfootAtM": 2000,
    "aggression": 0.5
  }
}
